import { Component } from '@angular/core';
import {MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-dialog-mean-cat',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    TranslateModule
  ],
  templateUrl: './dialog-mean-cat.component.html',
  styleUrl: './dialog-mean-cat.component.scss',
  standalone: true
})
export class DialogMeanCatComponent {

  showText = false;
  showButton1 = false;
  showButton2 = false;

  constructor(private dialogRef: MatDialogRef<DialogMeanCatComponent>) {}

  ngOnInit() {
    setTimeout(() => {
      this.showText = true;
    }, 3500);
    setTimeout(() => {
      this.showButton1 = true;
    }, 5000);
    setTimeout(() => {
      this.showButton2 = true;
    }, 6000);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  backToDashboard(){
    this.dialogRef.close(true);
  }

}
